import { useEffect } from "react";
import ListingNormal from "./ListingNormal";
import { useTheme } from "./ListingTheme";

export const ListingNew = ({ id }: { id: string }) => {
	const theme = useTheme();

	useEffect(() => {
		if (document) {
			document.body.style.background = theme?.background || "";
		}
		return () => {
			document.body.style.background = "";
		};
	}, []);
	return <ListingNormal id={id} />;
};
